import { render, staticRenderFns } from "./AudioMessage.vue?vue&type=template&id=6612aeee&"
import script from "./AudioMessage.vue?vue&type=script&lang=js&"
export * from "./AudioMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports